import { CSSProperties, PropsWithChildren, ReactNode } from 'react';

import { Grid, Stack, Typography, styled, Divider } from '@mui/material';

import { colors } from '@/theme/variables';

const Root = styled(Stack)(({ theme }) => ({
  position: 'relative',
  width: 'calc(100% - 2px)',
  backgroundColor:
    theme.palette.mode === 'light'
      ? theme.palette.background.paper
      : theme.palette.background.formHeader,
  borderRadius: 8,

  '&:first-of-type': {
    marginTop: 0,
  },

  'label span': {
    fontWeight: 600,
  },
  '.viewcard-title': {
    width: '100%',
    fontWeight: 500,
    backgroundColor:
      theme.palette.mode === 'light'
        ? theme.palette.background.formHeader
        : theme.palette.background.paper,
    padding: 8,
    borderRadius: '8px 8px 0 0',
  },
  '&.grey-title .viewcard-title:empty': {
    padding: 0,
    height: 1,
  },
  '&.red-title .viewcard-title': {
    backgroundColor: colors.error.light,
  },
  '&.red-title--v2 .viewcard-title': {
    backgroundColor: 'rgba(238, 62, 92, 0.4)',
    height: '40px',
    padding: '15px',
  },
}));

interface ViewCardProps extends PropsWithChildren {
  title: string | ReactNode;
  style?: CSSProperties;
  showDivider?: boolean;
  className?: string;
  contentContainerStyle?: CSSProperties;
}

export const ViewCard = ({
  title,
  style,
  contentContainerStyle,
  showDivider,
  children,
  ...rest
}: ViewCardProps) => {
  return (
    <>
      <Root spacing={2} style={style} {...rest}>
        <Stack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ my: 1 }}
        >
          {typeof title === 'string' ? (
            <Typography variant="inherit" className="viewcard-title">
              {title}
            </Typography>
          ) : (
            title
          )}
        </Stack>
        <Grid
          columnSpacing={3}
          container
          style={{
            ...contentContainerStyle,
          }}
        >
          {children}
        </Grid>
      </Root>
      {showDivider && <Divider sx={{ my: 3, width: '100%' }} />}
    </>
  );
};
